import React from 'react';
import Div, { type Props as DivProps } from '~/components/atom/Div';
import JustificationContainer from '~/components/atom/JustificationContainer';
import type { SystemSize } from '~/theme';

export type Props = DivProps & {
  align?: 'center' | 'start' | 'end';
  justify?: 'space-between' | 'start' | 'end';
  wrap?: 'wrap' | 'nowrap' | 'wrap-reverse' | 'unset';
  gap?: SystemSize | null;
};

const Toolbar: React.FCC<Props> = ({
  dataTestId,
  children,
  margin = [null],
  align = 'center',
  justify = 'space-between',
  wrap = 'unset',
  gap,
  padding = ['xxs'],
  ...rest
}) => (
  <Div
    data-testid={dataTestId}
    margin={margin}
    backgroundColor={{ group: 'white' }}
    border={{
      radius: 'm',
      width: 's',
      color: { group: 'tertiary', variant: 'light' },
    }}
    padding={padding}
    width="100%"
    {...rest}
  >
    <JustificationContainer
      justification={justify}
      align={align}
      wrap={wrap}
      gap={gap}
    >
      {children}
    </JustificationContainer>
  </Div>
);

export default Toolbar;
